import type { IssueStatus } from "./types";

/**
 * The user-facing name of each lifecycle state, in one place because both apps'
 * invoice list and create-invoice pages render it (FIN-603 — it was duplicated
 * byte-for-byte across `src/` and `apps/client/`).
 *
 * `issued` deliberately reads as "Sent": 'issued' is the stored value and the RPC's name,
 * but the action the user took was "Mark as sent" and Harmony never sends the email, so
 * showing them the schema word here would re-couple copy to the database.
 */
const STATUS_LABEL: Record<string, string> = {
  draft: "Draft",
  issued: "Sent",
  sent: "Sent",
  paid: "Paid",
  overdue: "Overdue",
  void: "Voided",
};

export function statusLabel(status: IssueStatus | string): string {
  return STATUS_LABEL[status] ?? status;
}
